import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/Services/User/user.service';
import { User } from 'src/app/Models/User';
import { Router } from '@angular/router';

@Component({
  selector: 'app-clubs',
  templateUrl: './clubs.component.html',
  styleUrls: ['./clubs.component.css'],
})
export class ClubsComponent implements OnInit {
  id: any;
  listClub: any;
  nclubs: any;
  Club: any = {};
  //titre: string;
  key: string;
  nClubs :any ; 

  constructor(private userservice: UserService, private router: Router) {}

  ngOnInit(): void {
    this.userservice.getAllClub().subscribe(
      (res) => {
        console.log(res);
        this.listClub = res;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getAllClubs() {
    this.userservice.getAllClub().subscribe(
      (data) => {
        this.listClub = data;
        this.nclubs = this.listClub.length;
        console.log(data);
        return this.listClub;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  searchUsers() {
    if (this.key) {
      this.userservice.searchUsers(this.key).subscribe(
        (response) => {
          this.listClub = response;
          // Handle the received user list data
        },
        (error) => {
          console.log(error);
          // Handle error
        }
      );
    } else {
      this.getAllClubs();
    }
  }



  
  countAllClubs() {
 
    this.userservice.getCountClub().subscribe(
      data => {
        this.nClubs = data;
        return this.nClubs;
      }
    )
  }
  setIdUser(id: any) {
    localStorage.setItem("IdUser", id);
  }

  // Inside your component class
  filterClubs() {
    const hostValue = (document.getElementById('host') as HTMLSelectElement)
      .value;
    const lieuValue = (document.getElementById('lieu') as HTMLSelectElement)
      .value;
    const universityValue = (
      document.getElementById('University') as HTMLSelectElement
    ).value;

    this.listClub = this.listClub.filter((item) => {
      if (
        (hostValue === 'Category' || item.Category === hostValue) &&
        (lieuValue === 'Region' || item.Region === lieuValue) &&
        (universityValue === 'University' ||
          item.University === universityValue)
      ) {
        return true;
      } else {
        return false;
      }
    });
  }
}